import { IGroup, IGroupData, IGroupParams, IGroupStudent, IShortItem, ITableRes } from 'types'
import { baseApi } from './baseApi'
import { MAX_PER_PAGE } from 'utils/constants'
import { translateGradeLevel } from 'utils/helpers'

export const groupsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_groups: builder.query<ITableRes<IGroup>, IGroupParams>({
      query: (params) => ({
        url: '/groups/',
        params,
      }),
      providesTags: ['groups'],
    }),
    GET_groupById: builder.query<IGroup, string>({
      query: (id) => {
        return {
          url: `/groups/${id}/`,
        }
      },
      transformResponse: (response: any): any => {
        return {
         ...response,
         mentor: {id: response?.mentor_id, title: response?.mentor},
         grade_level_option: {id: response?.grade_level, title: `${translateGradeLevel(response?.grade_level, true)}`},
         academic_year: {id: response?.academic_year, title: `${response?.academic_year}`},
        }
      },
      providesTags: ['group']
    }),
    POST_group: builder.mutation<IGroup, IGroupData>({
      query: (body) => ({
        url: `/groups/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['groups'],
    }),
    PUT_group: builder.mutation<IGroup, { id: string; body: IGroupData }>({
      query: ({ id, body }) => ({
        url: `/groups/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['groups', 'group'],
    }),
    DELETE_group: builder.mutation<IGroup, string>({
      query: (id) => ({
        url: `/groups/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['groups'],
    }),
    PUT_addStudentToGroup: builder.mutation<IGroupStudent, IGroupStudent>({
      query: (body) => ({
        url: `/groups/add_student_to_group/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['group', 'students'],
    }),
    PUT_removeStudentFromGroup: builder.mutation<IGroupStudent, IGroupStudent>({
      query: (body) => ({
        url: `/groups/remove_student_from_group/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['group', 'students'],
    }),  
    GET_studentGroups: builder.query<any, void>({
      query: () => ({
        url: '/groups/select/',
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        const list = response?.results || []
        return {
          list,
          count,
          hasMore,
        }
      },
      providesTags: ['student-groups'],
    }),
    GET_groupSelect: builder.query<ITableRes<IShortItem>, IGroupParams>({
      query: (params) => ({
        url: '/groups/select/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      providesTags: ['groups'],
      transformResponse: (response: ITableRes<IShortItem>): any => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        const list = response?.results || []
        return {
          list,
          count,
          hasMore,
        }
      },
    }),
  }),
})

export const { 
  useGET_groupsQuery, 
  useGET_groupByIdQuery, 
  usePOST_groupMutation, 
  usePUT_groupMutation, 
  useDELETE_groupMutation,
  usePUT_addStudentToGroupMutation, 
  usePUT_removeStudentFromGroupMutation, 
  useGET_studentGroupsQuery, 
  useGET_groupSelectQuery 
} = groupsAPI
